import {SelectedColors} from "data/models/survey/colors";

export const defaultBrandColors: SelectedColors = {
  primary: {
    color: "#666666",
    trait: "",
  },
  secondary: {
    color: "#999999",
    trait: "",
  },
  accent: {
    color: "#000000",
    trait: "",
  },
  background: {
    color: "#D8D8D8",
    trait: "",
  }
}
